import * as _ from 'lodash';
import { IApiError } from '@models/iapi';
import { Injector } from '@angular/core';
import { AlertToastService } from '@services';

export function checkErrors(data: any, injector: Injector, typeMessage = null): any {
  const alertToastService = injector.get(AlertToastService);

  data = data.data;
  let responseErrors: any[] = _.get(data, 'data[0].Data.Errors', []);
  let responseWarnings: any[] = _.get(data, 'data[0].Data.Warnings', []);
  let successArray = _.get(data, 'data[0].Success', []);
  const responseErrors1: any[] = _.get(data, 'data[0].Errors', []);
  const responseWarnings1: any[] = _.get(data, 'data[0].Warnings', []);

  if (!responseErrors.length && responseErrors1.length) {
    responseErrors = responseErrors1;
  }

  if (!responseWarnings.length && responseWarnings1.length) {
    responseWarnings = responseWarnings1;
  }

  if (typeMessage === 'Помилка видалення') {
    responseErrors = _.get(data, 'data.DocumentRefs.Errors', []);
    successArray = _.get(data, 'data.DocumentRefs.Success', []);
  }

  if ((responseErrors[0] || responseWarnings[0]) && typeMessage) {
    const errors: Set<IApiError> = new Set();

    responseErrors.map(el => errors.add(el.Error));
    responseWarnings.map(el => errors.add(el.Warning));

    if (errors.size) {
      if (!successArray.length) {
        alertToastService.pushRegisterApiErrors(
          Array.from(errors),
          typeMessage === 'Помилка додавання'
            ? 'Попередження! Обрані документи не додано до реєстру'
            : 'Попередження! Обрані документи не видалено з реєстру',
          typeMessage,
        );
      } else {
        alertToastService.pushRegisterApiErrors(
          Array.from(errors),
          typeMessage === 'Помилка додавання'
            ? 'Попередження! Не всі документи додано до реєстру'
            : 'Попередження! Не всі документи видалено з реєстру',
          typeMessage,
        );
      }
    }

    throw errors;
  }

  return data;
}
